export default "__VITE_ASSET__18937d43__"